import { all } from 'iso-3166-1'

import type { FieldDefinitionOption } from '../../types/field-types'

const COUNTRY_SUBDIVISIONS: Record<string, { value: string; label: string }[]> =
  {
    NL: [
      { value: 'Drenthe', label: 'Drenthe' },
      { value: 'Flevoland', label: 'Flevoland' },
      { value: 'Friesland', label: 'Friesland' },
      { value: 'Gelderland', label: 'Gelderland' },
      { value: 'Groningen', label: 'Groningen' },
      { value: 'Limburg', label: 'Limburg' },
      { value: 'Noord-Brabant', label: 'Noord-Brabant' },
      { value: 'Noord-Holland', label: 'Noord-Holland' },
      { value: 'Overijssel', label: 'Overijssel' },
      { value: 'Utrecht', label: 'Utrecht' },
      { value: 'Zeeland', label: 'Zeeland' },
      { value: 'Zuid-Holland', label: 'Zuid-Holland' },
    ],
    BE: [
      { value: 'Antwerpen', label: 'Antwerpen' },
      {
        value: 'Brussels Hoofdstedelijk Gewest',
        label: 'Brussels Hoofdstedelijk Gewest',
      },
      { value: 'Henegouwen', label: 'Henegouwen' },
      { value: 'Luik', label: 'Luik' },
      { value: 'Limburg', label: 'Limburg' },
      { value: 'Luxemburg', label: 'Luxemburg' },
      { value: 'Namen', label: 'Namen' },
      { value: 'Oost-Vlaanderen', label: 'Oost-Vlaanderen' },
      { value: 'Vlaams-Brabant', label: 'Vlaams-Brabant' },
      { value: 'Waals-Brabant', label: 'Waals-Brabant' },
      { value: 'West-Vlaanderen', label: 'West-Vlaanderen' },
    ],
    DE: [
      { value: 'Baden-Württemberg', label: 'Baden-Württemberg' },
      { value: 'Bayern', label: 'Bayern' },
      { value: 'Berlin', label: 'Berlin' },
      { value: 'Brandenburg', label: 'Brandenburg' },
      { value: 'Bremen', label: 'Bremen' },
      { value: 'Hamburg', label: 'Hamburg' },
      { value: 'Hessen', label: 'Hessen' },
      { value: 'Mecklenburg-Vorpommern', label: 'Mecklenburg-Vorpommern' },
      { value: 'Niedersachsen', label: 'Niedersachsen' },
      { value: 'Nordrhein-Westfalen', label: 'Nordrhein-Westfalen' },
      { value: 'Rheinland-Pfalz', label: 'Rheinland-Pfalz' },
      { value: 'Saarland', label: 'Saarland' },
      { value: 'Sachsen', label: 'Sachsen' },
      { value: 'Sachsen-Anhalt', label: 'Sachsen-Anhalt' },
      { value: 'Schleswig-Holstein', label: 'Schleswig-Holstein' },
      { value: 'Thüringen', label: 'Thüringen' },
    ],
  }

export function getCountryFieldOptions(
  translate: (key: string) => string,
  placeholderKey = 'common.fieldPlaceholder.country'
): FieldDefinitionOption[] {
  return [
    {
      labelKey: placeholderKey,
      value: '',
      disabled: true,
    },
    ...all()
      .map(country => {
        const key = `iso3166.${country.alpha2}`
        const translated = translate(key)
        return {
          labelKey:
            translated && translated !== key ? translated : country.country,
          value: country.alpha2,
        }
      })
      .sort((a, b) => a.labelKey.localeCompare(b.labelKey)),
  ]
}

export function getProvinceStateFieldOptions(
  countryCode: string | null | undefined,
  placeholderKey = 'common.fieldPlaceholder.provinceState'
): FieldDefinitionOption[] {
  if (!countryCode) {
    return []
  }

  const subdivisions = COUNTRY_SUBDIVISIONS[countryCode] ?? []
  if (subdivisions.length === 0) {
    return []
  }

  return [
    {
      labelKey: placeholderKey,
      value: '',
      disabled: true,
    },
    ...subdivisions.map(subdivision => ({
      labelKey: subdivision.label,
      value: subdivision.value,
    })),
  ]
}
